import DOMPurify from "dompurify";

/**
 * Sanitize an HTML string before binding it via `v-html`.
 * Strips `<script>`, inline event handlers and dangerous URLs while keeping safe markup.
 */
export function sanitizeHtml(html?: string | null): string {
  return DOMPurify.sanitize(html ?? "");
}

/**
 * Return `url` only when it uses a safe `http(s)` scheme, otherwise `undefined`.
 * Use for `:href` / `:src` bound to backend-provided URLs so a `javascript:` / `data:`
 * scheme can't execute when the link is opened.
 */
export function safeExternalUrl(url?: string | null): string | undefined {
  if (!url) return undefined;
  const trimmed = url.trim();
  return /^https?:\/\//i.test(trimmed) ? trimmed : undefined;
}
